import { useCallback, useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import { Loader } from "semantic-ui-react";
import { InProgressReportCard } from "../../containers/ReportCard/InProgressReportCard";
import { IReport } from "../../models/report";
import { getInProgressReports } from "../../services/reportsService";
import { responsiveCarousel } from "../../helpers/commonHelper";

interface IProps {
    withDelete?: boolean;
    isInternal: boolean;
    refreshReports?: boolean;
}

export const ReportsCarousel = ({ withDelete, isInternal, refreshReports }: IProps) => {
    const [inProgressReports, setInProgressReports] = useState<IReport[]>([]);
    const [loadingReports, setLoadingReports] = useState(true);

    const fetchInProgressReports = useCallback(async () => {
        setLoadingReports(true);
        const reports = await getInProgressReports(isInternal);
        Array.isArray(reports) && setInProgressReports(reports);
        setLoadingReports(false);
    }, []);

    useEffect(() => {
        fetchInProgressReports();
    }, [fetchInProgressReports, refreshReports]);

    return (
        <>
            <Loader active={loadingReports} inline="centered" />
            <Carousel responsive={responsiveCarousel}>
                {inProgressReports.map(x => (
                    <div className="action-bar-container" key={x.id}>
                        <InProgressReportCard
                            report={x}
                            withDelete={withDelete}
                            refresh={fetchInProgressReports}
                        />
                    </div>
                ))}
            </Carousel>
            {inProgressReports.length === 0 && !loadingReports && <b>No reports in progress.</b>}
        </>
    );
};
